import { useSalesRatioByChannelQuery } from '@/generated/graphql-react-query';

export const useSalesRatioByChannel = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) => {
  const { data, isLoading } = useSalesRatioByChannelQuery({
    input: {
      filter: {
        startedAt: startDate,
        endAt: endDate,
      },
    },
  });

  return {
    data: data?.salesRatioByChannel || [],
    isLoading,
  };
};
